export const REQUEST_STATE = 'REQUEST_STATE';
export const SET_ERROR = 'SET_ERROR';
export const SET_LOADING = 'SET_LOADING';

export const LOGOUT = 'LOGOUT';
export const CORE_GET_SYSTEM_INFO_REQUEST = 'CORE_GET_SYSTEM_INFO_REQUEST';
export const CORE_GET_SYSTEM_INFO_SUCCESS = 'CORE_GET_SYSTEM_INFO_SUCCESS';
export const CORE_GET_SYSTEM_INFO_FAILURE = 'CORE_GET_SYSTEM_INFO_FAILURE';

export const CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST';
export const CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS';
export const CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE';

export const CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST';
export const CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS';
export const CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE';

export const CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST';
export const CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS';
export const CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE';

export const CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST';
export const CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS';
export const CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE';

export const CORE_SET_USER_APPROVE_REQUEST = 'CORE_SET_USER_APPROVE_REQUEST';
export const CORE_SET_USER_APPROVE_SUCCESS = 'CORE_SET_USER_APPROVE_SUCCESS';
export const CORE_SET_USER_APPROVE_FAILURE = 'CORE_SET_USER_APPROVE_FAILURE';

export const CORE_SET_USER_SUBMIT_REQUEST = 'CORE_SET_USER_SUBMIT_REQUEST';
export const CORE_SET_USER_SUBMIT_SUCCESS = 'CORE_SET_USER_SUBMIT_SUCCESS';
export const CORE_SET_USER_SUBMIT_FAILURE = 'CORE_SET_USER_SUBMIT_FAILURE';

//AUTH
export const CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
export const CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
export const CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

//AUTH BYPASS
export const CORE_AUTH_VERIFY_BYPASS_REQUEST = 'CORE_AUTH_VERIFY_BYPASS_REQUEST';
export const CORE_AUTH_VERIFY_BYPASS_SUCCESS = 'CORE_AUTH_VERIFY_BYPASS_SUCCESS';
export const CORE_AUTH_VERIFY_BYPASS_FAILURE = 'CORE_AUTH_VERIFY_BYPASS_FAILURE';

export const CORE_GET_REQUEST_INFO_REQUEST = 'CORE_GET_REQUEST_INFO_REQUEST';
export const CORE_GET_REQUEST_INFO_SUCCESS = 'CORE_GET_REQUEST_INFO_SUCCESS';
export const CORE_GET_REQUEST_INFO_FAILURE = 'CORE_GET_REQUEST_INFO_FAILURE';

//MASTER
export const CORE_GET_MASTERS_REQUEST = 'CORE_GET_MASTERS_REQUEST';
export const CORE_GET_MASTERS_SUCCESS = 'CORE_GET_MASTERS_SUCCESS';
export const CORE_GET_MASTERS_FAILURE = 'CORE_GET_MASTERS_FAILURE';

// ALL MY MASTER
export const CORE_GET_ALL_MYTASKS_REQUEST = 'CORE_GET_ALL_MYTASKS_REQUEST';
export const CORE_GET_ALL_MYTASKS_SUCCESS = 'CORE_GET_ALL_MYTASKS_SUCCESS';
export const CORE_GET_ALL_MYTASKS_FAILURE = 'CORE_GET_ALL_MYTASKS_FAILURE';

// MY TASK BY ID
export const CORE_GET_MYTASK_BY_ID_REQUEST = 'CORE_GET_MYTASK_BY_ID_REQUEST';
export const CORE_GET_MYTASK_BY_ID_SUCCESS = 'CORE_GET_MYTASK_BY_ID_SUCCESS';
export const CORE_GET_MYTASK_BY_ID_FAILURE = 'CORE_GET_MYTASK_BY_ID_FAILURE';

// CREATE TASK
export const CORE_CREATE_MYTASK_REQUEST = 'CORE_CREATE_MYTASK_REQUEST';
export const CORE_CREATE_MYTASK_SUCCESS = 'CORE_CREATE_MYTASK_SUCCESS';
export const CORE_CREATE_MYTASK_FAILURE = 'CORE_CREATE_MYTASK_FAILURE';

// SUBMIT TASK
export const CORE_SUBMIT_TASK_REQUEST = 'CORE_SUBMIT_TASK_REQUEST';
export const CORE_SUBMIT_TASK_SUCCESS = 'CORE_SUBMIT_TASK_SUCCESS';
export const CORE_SUBMIT_TASK_FAILURE = 'CORE_SUBMIT_TASK_FAILURE';

// COMMENT TASK
export const CORE_COMMENT_TASK_REQUEST = 'CORE_COMMENT_TASK_REQUEST';
export const CORE_COMMENT_TASK_SUCCESS = 'CORE_COMMENT_TASK_SUCCESS';
export const CORE_COMMENT_TASK_FAILURE = 'CORE_COMMENT_TASK_FAILURE';

// ALL TASK ASSIGN
export const CORE_GET_ALL_MY_ASSIGN_REQUEST = 'CORE_GET_ALL_MY_ASSIGN_REQUEST';
export const CORE_GET_ALL_MY_ASSIGN_SUCCESS = 'CORE_GET_ALL_MY_ASSIGN_SUCCESS';
export const CORE_GET_ALL_MY_ASSIGN_FAILURE = 'CORE_GET_ALL_MY_ASSIGN_FAILURE';

// TASK ASSIGN BY ID
export const CORE_GET_ASSIGN_TASK_BY_ID_REQUEST = 'CORE_GET_ASSIGN_TASK_BY_ID_REQUEST';
export const CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS = 'CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS';
export const CORE_GET_ASSIGN_TASK_BY_ID_FAILURE = 'CORE_GET_ASSIGN_TASK_BY_ID_FAILURE';

// INPROGRESS TASK
export const CORE_IN_PROGRESS_TASK_REQUEST = 'CORE_IN_PROGRESS_TASK_REQUEST';
export const CORE_IN_PROGRESS_TASK_SUCCESS = 'CORE_IN_PROGRESS_TASK_SUCCESS';
export const CORE_IN_PROGRESS_TASK_FAILURE = 'CORE_IN_PROGRESS_TASK_FAILURE';

// ALL TASK DRAFT
export const CORE_GET_ALL_MY_DRAFT_REQUEST = 'CORE_GET_ALL_MY_DRAFT_REQUEST';
export const CORE_GET_ALL_MY_DRAFT_SUCCESS = 'CORE_GET_ALL_MY_DRAFT_SUCCESS';
export const CORE_GET_ALL_MY_DRAFT_FAILURE = 'CORE_GET_ALL_MY_DRAFT_FAILURE';

// DRAFT TASK BY ID
export const CORE_GET_DRAFT_TASK_BY_ID_REQUEST = 'CORE_GET_DRAFT_TASK_BY_ID_REQUEST';
export const CORE_GET_DRAFT_TASK_BY_ID_SUCCESS = 'CORE_GET_DRAFT_TASK_BY_ID_SUCCESS';
export const CORE_GET_DRAFT_TASK_BY_ID_FAILURE = 'CORE_GET_DRAFT_TASK_BY_ID_FAILURE';

// WAITING_TEST
export const CORE_WAITING_TEST_ASSIGN_TASK_REQUEST = 'CORE_WAITING_TEST_ASSIGN_TASK_REQUEST';
export const CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS = 'CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS';
export const CORE_WAITING_TEST_ASSIGN_TASK_FAILURE = 'CORE_WAITING_TEST_ASSIGN_TASK_FAILURE';

// DONE
export const CORE_DONE_ASSIGN_TASK_REQUEST = 'CORE_DONE_ASSIGN_TASK_REQUEST';
export const CORE_DONE_ASSIGN_TASK_SUCCESS = 'CORE_DONE_ASSIGN_TASK_SUCCESS';
export const CORE_DONE_ASSIGN_TASK_FAILURE = 'CORE_DONE_ASSIGN_TASK_FAILURE';

// DISCUSS
export const CORE_DISCUSS_ASSIGN_TASK_REQUEST = 'CORE_DISCUSS_ASSIGN_TASK_REQUEST';
export const CORE_DISCUSS_ASSIGN_TASK_SUCCESS = 'CORE_DISCUSS_ASSIGN_TASK_SUCCESS';
export const CORE_DISCUSS_ASSIGN_TASK_FAILURE = 'CORE_DISCUSS_ASSIGN_TASK_FAILURE';

// ATTACH
export const CORE_ATTACH_TASK_REQUEST = 'CORE_ATTACH_TASK_REQUEST';
export const CORE_ATTACH_TASK_SUCCESS = 'CORE_ATTACH_TASK_SUCCESS';
export const CORE_ATTACH_TASK_FAILURE = 'CORE_ATTACH_TASK_FAILURE';

// CLOSED_TASK
export const CORE_CLOSED_TASK_REQUEST = 'CORE_CLOSED_TASK_REQUEST';
export const CORE_CLOSED_TASK_SUCCESS = 'CORE_CLOSED_TASK_SUCCESS';
export const CORE_CLOSED_TASK_FAILURE = 'CORE_CLOSED_TASK_FAILURE';

// CANCEL_TASK
export const CORE_CANCEL_TASK_REQUEST = 'CORE_CANCEL_TASK_REQUEST';
export const CORE_CANCEL_TASK_SUCCESS = 'CORE_CANCEL_TASK_SUCCESS';
export const CORE_CANCEL_TASK_FAILURE = 'CORE_CANCEL_TASK_FAILURE';

// REOPEN
export const CORE_REOPEN_TASK_REQUEST = 'CORE_REOPEN_TASK_REQUEST';
export const CORE_REOPEN_TASK_SUCCESS = 'CORE_REOPEN_TASK_SUCCESS';
export const CORE_REOPEN_TASK_FAILURE = 'CORE_REOPEN_TASK_FAILURE';

// DOWNLOAD_ONEDIRVE_FILE
export const CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST = 'CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST';
export const CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS = 'CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS';
export const CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE = 'CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE';

export const CORE_GET_OIL_PRICE_REQUEST = 'CORE_GET_OIL_PRICE_REQUEST';
export const CORE_GET_OIL_PRICE_SUCCESS = 'CORE_GET_OIL_PRICE_SUCCESS';
export const CORE_GET_OIL_PRICE_FAILURE = 'CORE_GET_OIL_PRICE_FAILURE';

export const CORE_GET_OIL_PRICES_REQUEST = 'CORE_GET_OIL_PRICES_REQUEST';
export const CORE_GET_OIL_PRICES_SUCCESS = 'CORE_GET_OIL_PRICES_SUCCESS';
export const CORE_GET_OIL_PRICES_FAILURE = 'CORE_GET_OIL_PRICES_FAILURE';

// UPDATE MY TASK
export const CORE_UPDATE_MYTASK_REQUEST = 'CORE_UPDATE_MYTASK_REQUEST';
export const CORE_UPDATE_MYTASK_SUCCESS = 'CORE_UPDATE_MYTASK_SUCCESS';
export const CORE_UPDATE_MYTASK_FAILURE = 'CORE_UPDATE_MYTASK_FAILURE';

export const CORE_UPDATE_TASK_REQUEST = 'CORE_UPDATE_TASK_REQUEST';
export const CORE_UPDATE_TASK_SUCCESS = 'CORE_UPDATE_TASK_SUCCESS';
export const CORE_UPDATE_TASK_FAILURE = 'CORE_UPDATE_TASK_FAILURE';

export const CORE_GET_SETTINGS_REQUEST = 'CORE_GET_SETTINGS_REQUEST';
export const CORE_GET_SETTINGS_SUCCESS = 'CORE_GET_SETTINGS_SUCCESS';
export const CORE_GET_SETTINGS_FAILURE = 'CORE_GET_SETTINGS_FAILURE';

// COURSE
export const CORE_GET_ALL_COURSE_INCOMING_REQUEST = 'CORE_GET_ALL_COURSE_INCOMING_REQUEST';
export const CORE_GET_ALL_COURSE_INCOMING_SUCCESS = 'CORE_GET_ALL_COURSE_INCOMING_SUCCESS';
export const CORE_GET_ALL_COURSE_INCOMING_FAILURE = 'CORE_GET_ALL_COURSE_INCOMING_FAILURE';

export const CORE_GET_ALL_COURSE_HISTORY_REQUEST = 'CORE_GET_ALL_COURSE_HISTORY_REQUEST';
export const CORE_GET_ALL_COURSE_HISTORY_SUCCESS = 'CORE_GET_ALL_COURSE_HISTORY_SUCCESS';
export const CORE_GET_ALL_COURSE_HISTORY_FAILURE = 'CORE_GET_ALL_COURSE_HISTORY_FAILURE';

export const CORE_GET_COURSE_BY_ID_INCOMING_REQUEST = 'CORE_GET_COURSE_BY_ID_INCOMING_REQUEST';
export const CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS = 'CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS';
export const CORE_GET_COURSE_BY_ID_INCOMING_FAILURE = 'CORE_GET_COURSE_BY_ID_INCOMING_FAILURE';

export const CORE_GET_REQUEST_TO_JOIN_COURSE_REQUEST = 'CORE_GET_REQUEST_TO_JOIN_COURSE_REQUEST';
export const CORE_GET_REQUEST_TO_JOIN_COURSE_SUCCESS = 'CORE_GET_REQUEST_TO_JOIN_COURSE_SUCCESS';
export const CORE_GET_REQUEST_TO_JOIN_COURSE_FAILURE = 'CORE_GET_REQUEST_TO_JOIN_COURSE_FAILURE';

export const CORE_GET_ALL_CAR_RESERVE_REQUEST = 'CORE_GET_ALL_CAR_RESERVE_REQUEST';
export const CORE_GET_ALL_CAR_RESERVE_SUCCESS = 'CORE_GET_ALL_CAR_RESERVE_SUCCESS';
export const CORE_GET_ALL_CAR_RESERVE_FAILURE = 'CORE_GET_ALL_CAR_RESERVE_FAILURE';

export const CORE_GET_CAR_RESERVE_BY_ID_REQUEST = 'CORE_GET_CAR_RESERVE_BY_ID_REQUEST';
export const CORE_GET_CAR_RESERVE_BY_ID_SUCCESS = 'CORE_GET_CAR_RESERVE_BY_ID_SUCCESS';
export const CORE_GET_CAR_RESERVE_BY_ID_FAILURE = 'CORE_GET_CAR_RESERVE_BY_ID_FAILURE';

export const CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST = 'CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST';
export const CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS = 'CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS';
export const CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE = 'CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE';

export const CORE_CREATE_CAR_RESERVE_REQUEST = 'CORE_CREATE_CAR_RESERVE_REQUEST';
export const CORE_CREATE_CAR_RESERVE_SUCCESS = 'CORE_CREATE_CAR_RESERVE_SUCCESS';
export const CORE_CREATE_CAR_RESERVE_FAILURE = 'CORE_CREATE_CAR_RESERVE_FAILURE';

export const CORE_UPDATE_CAR_RESERVE_REQUEST = 'CORE_UPDATE_CAR_RESERVE_REQUEST';
export const CORE_UPDATE_CAR_RESERVE_SUCCESS = 'CORE_UPDATE_CAR_RESERVE_SUCCESS';
export const CORE_UPDATE_CAR_RESERVE_FAILURE = 'CORE_UPDATE_CAR_RESERVE_FAILURE';

export const CORE_CANCEL_CAR_RESERVE_REQUEST = 'CORE_CANCEL_CAR_RESERVE_REQUEST';
export const CORE_CANCEL_CAR_RESERVE_SUCCESS = 'CORE_CANCEL_CAR_RESERVE_SUCCESS';
export const CORE_CANCEL_CAR_RESERVE_FAILURE = 'CORE_CANCEL_CAR_RESERVE_FAILURE';

export const CORE_REJECT_CAR_RESERVE_REQUEST = 'CORE_REJECT_CAR_RESERVE_REQUEST';
export const CORE_REJECT_CAR_RESERVE_SUCCESS = 'CORE_REJECT_CAR_RESERVE_SUCCESS';
export const CORE_REJECT_CAR_RESERVE_FAILURE = 'CORE_REJECT_CAR_RESERVE_FAILURE';

export const CORE_GET_ALL_MY_CAR_RESERVE_REQUEST = 'CORE_GET_ALL_MY_CAR_RESERVE_REQUEST';
export const CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS = 'CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS';
export const CORE_GET_ALL_MY_CAR_RESERVE_FAILURE = 'CORE_GET_ALL_MY_CAR_RESERVE_FAILURE';

export const CORE_START_CAR_DRIVER_REQUEST = 'CORE_START_CAR_DRIVER_REQUEST';
export const CORE_START_CAR_DRIVER_SUCCESS = 'CORE_START_CAR_DRIVER_SUCCESS';
export const CORE_START_CAR_DRIVER_FAILURE = 'CORE_START_CAR_DRIVER_FAILURE';

export const CORE_END_CAR_DRIVER_REQUEST = 'CORE_END_CAR_DRIVER_REQUEST';
export const CORE_END_CAR_DRIVER_SUCCESS = 'CORE_END_CAR_DRIVER_SUCCESS';
export const CORE_END_CAR_DRIVER_FAILURE = 'CORE_END_CAR_DRIVER_FAILURE';

export const GET_LOCATION_SEARCH_REQUEST = 'GET_LOCATION_SEARCH_REQUEST';
export const GET_LOCATION_SEARCH_SUCCESS = 'GET_LOCATION_SEARCH_SUCCESS';
export const GET_LOCATION_SEARCH_FAILURE = 'GET_LOCATION_SEARCH_FAILURE';

export const CORE_GET_ALL_PROJECT_REQUEST = 'CORE_GET_ALL_PROJECT_REQUEST';
export const CORE_GET_ALL_PROJECT_SUCCESS = 'CORE_GET_ALL_PROJECT_SUCCESS';
export const CORE_GET_ALL_PROJECT_FAILURE = 'CORE_GET_ALL_PROJECT_FAILURE';

export const CORE_GET_PROJECT_REQUEST = 'CORE_GET_PROJECT_REQUEST';
export const CORE_GET_PROJECT_SUCCESS = 'CORE_GET_PROJECT_SUCCESS';
export const CORE_GET_PROJECT_FAILURE = 'CORE_GET_PROJECT_FAILURE';

export const CORE_CREATE_PROJECT_REQUEST = 'CORE_CREATE_PROJECT_REQUEST';
export const CORE_CREATE_PROJECT_SUCCESS = 'CORE_CREATE_PROJECT_SUCCESS';
export const CORE_CREATE_PROJECT_FAILURE = 'CORE_CREATE_PROJECT_FAILURE';

export const CORE_UPDATE_PROJECT_REQUEST = 'CORE_UPDATE_PROJECT_REQUEST';
export const CORE_UPDATE_PROJECT_SUCCESS = 'CORE_UPDATE_PROJECT_SUCCESS';
export const CORE_UPDATE_PROJECT_FAILURE = 'CORE_UPDATE_PROJECT_FAILURE';

export const CORE_GET_APPROVE_LIST_REQUEST = 'CORE_GET_APPROVE_LIST_REQUEST';
export const CORE_GET_APPROVE_LIST_SUCCESS = 'CORE_GET_APPROVE_LIST_SUCCESS';
export const CORE_GET_APPROVE_LIST_FAILURE = 'CORE_GET_APPROVE_LIST_FAILURE';



// WEBPACK FOOTER //
// ./src/app/redux/types.js